module.exports = __webpack_public_path__ + "static/media/padlock.de167710.svg";